<template>
  <!-- 2カラムページの場合は'is-2column'クラスを付与 -->
  <!-- ヘッダーを隠すの場合は'is-hidden-header'クラスを付与 -->
  <div id="body"
    :class="{'is-hidden-header' : targetScrollFlg}"
    @scroll="handleScroll"
  >
  <BackgroundImage />

    <!-- menu:start -->
    <PCMenu
      class="visible"
      v-if="visibleMenu"
      @closeMenu="visibleMenu = false"
    />
    <!-- menu:end -->

    <!-- View Confirm Popup -->
    <transition name="popup">
      <PCContractFreeTrialRequestConfirm
        v-if="trial.visiblePopup === 'confirm'"
        @closeViewConfirm="action.close"
        @openViewComplete="action.complete"
      />
    </transition>

    <!-- View Complete Popup -->
    <transition name="popup">
      <PCContractFreeTrialRequestComplete
        v-if="trial.visiblePopup === 'complete'"
        @closeViewComplete="action.finish"
      />
    </transition>

    <div id="wrapper">
      <PCContractHeader />

      <!-- menu-bar:start -->
      <!-- open -->
      <div class="menu-bar" role="button"
        :class="{'is-open' : !targetScrollFlg}"
        @click="visibleMenu = !visibleMenu"
      >
        <IconMenu class="icn"
          v-if="!targetScrollFlg"
        />
        <FontawesomeIcon :icon="['far','chevron-up']" size="lg" class="icn"
          v-if="targetScrollFlg"
        />
      </div>
      <!-- close -->
      <!-- menu-bar:end -->

      <!-- content:start -->
      <div id="content"
        style="height:calc(100vh - 16px);"
        >
        <div class="contract" id="scroll-target"
          @scroll="handleScroll"
          >
          <div class="contract-head">
            <h1 class="hdg03">無料トライアルの申し込み</h1>
          </div>
          <form action="" method="post" class="contract-container">
            <div class="contract-content">
              <!-- <p class="txt-head">無料トライアルの注記無料トライアルの注記無料トライアルの注記無料トライアルの注記無料トライアルの注記無料トライアルの注記無料トライアルの注記</p> -->

              <h2 class="hdg03 mt0">無料トライアルを希望するパッケージ </h2>
              <div class="contract-content-payment">
                <p class="txt">希望するパッケージにチェックをいれてください。</p>
                <div class="contract-content-formparts">
                  <div v-for="(product, index) in canTrialProduct" :key="index" class="formparts checkbox">
                    <input type="checkbox" :value="product.code" :id="'cb_' + index" v-model="trialState.products">
                    <label :for="'cb_' + index">{{product.name}}<FontawesomeIcon icon="check" class="icn" /></label>
                  </div>
                </div>
              </div>
              <h2 class="hdg03">弊社社員からの紹介</h2>
              <div class="contract-content-payment">
                <p class="txt">弊社社員からの紹介であれば社員名を入力してください。</p>
                <div class="contract-content-input">
                  <div class="formparts text">
                    <input type="text" placeholder="山田 太郎" v-model="trialState.chargeName">
                  </div>
                </div>
                <p class="txt-sup">不明の場合は入力不要です。<br>この欄に弊社社員名以外の入力をされてもご対応致しかねます。</p>
                <div class="contract-btn">
                  <div :class="['button', trialState.products.length <= 0 && 'is-inactive']">
                    <span class="btn" @click="action.confirm" role="button">確認</span>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <!-- content:end -->
      <span id="btnTop" @click="scrollAreaTop('#scroll-target')">TOP</span>
    </div>
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api'
import { ContractFreeTrialRequestInput } from '@/logic/contract/ContractFreeTrialRequestInput'

import PCContractHeader from '@/components/pc/partial/contract/ContractHeader.vue'
import PCMenu from '@/components/pc/popup/PCMenu.vue'
import PCContractFreeTrialRequestConfirm from '@/components/pc/popup/PCContractFreeTrialRequestConfirm.vue'
import PCContractFreeTrialRequestComplete from '@/components/pc/popup/PCContractFreeTrialRequestComplete.vue'

export default defineComponent({
  components: {
    PCContractHeader,
    PCMenu,
    PCContractFreeTrialRequestConfirm,
    PCContractFreeTrialRequestComplete
  },
  setup (props, context) {
    return { ...ContractFreeTrialRequestInput(props, context) }
  }
})
</script>

<style lang="scss" scoped>
#header {
  @media screen and (max-width: 1250px) {
    .header-search-tab {
      position: relative;
      &-02 {
        position: absolute;
        top: 52px;
        background-color: #fff;
        border-radius: 4px;
        box-shadow: 0px 3px 6px rgba(0,0,0,.16);
        .header-search-tab-item {
          height: 48px;
          padding: 0 10px;
          a {
            color: $color-link;
            padding: 2px 10px;
            font-size: 1.4rem;
          }
        }
      }
    }
  } 
}
#content {
  background-color: #fff;
  border-radius: 8px 8px 0 0;
  margin-bottom: 60px;
  overflow-y: auto;
}
.contract {
  width: 100%;
  overflow: auto;
  &-container {
    border-top: 1px solid $color-line;
    padding: 43px 0 150px;
    .button .btn[type="submit"] {
      width: 230px;
      margin: 32px auto 0;
    }
  }
  &-head {
    padding: 30px 40px 25px;
    [class^="hdg"] {
      margin-bottom: 0;
    }
  }
  &-content {
    max-width: 1105px;
    padding: 0 40px;
    margin: 0 auto;
    .hdg03{
      margin: 62px 0 15px;
    }
    .txt {
      line-height: 1.625;
      &-head{
        font-size: 18px;
        line-height: 2;
        padding-bottom: 10px;
        color: #555;
      }
    }
    .link{
      text-decoration: underline;
      svg{
        margin-left: 5px;
      }
    }
    &-formparts{
      padding-top: 8px;
      .formparts + .formparts{
        margin-top: 22px;
      }
    }
    &-input{
      width: 480px;
    }
    &-payment {
      border-top: 1px solid $color-line;
      padding: 32px 0;
      .txt{
        margin-bottom: 20px;
      }
      .txt-sup{
        margin-top: 20px;
        margin-bottom: 0;
      }
      &+ .hdg03{
        margin-top: 47px;
      }
    }
  }
  &-btn{
    width: 230px;
    margin: 0 auto;
    padding-top: 32px;
  }
}
</style>
